module.exports = __webpack_public_path__ + "img/for_one.2ddfc597.png";